var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 15.9448,
    height: 15.9953,
    viewBox: "0 0 15.9448 15.9953",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9448 7.99767C15.9448 12.4146 12.3754 15.9953 7.97242 15.9953C3.56941 15.9953 0 12.4146 0 7.99767C0 3.58072 3.56941 0 7.97242 0H15.9448V7.99767Z",
    fill: "#D4623A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif40);
export default __webpack_public_path__ + "static/media/motif-40.81a1b866d4a52fce05d8773fa8077559.svg";
export { ForwardRef as ReactComponent };